module.exports = new Promise(async (resolve, reject) => {
  try {
    const module = await import('https://sn2-care-journal-devb.web.app/assets/remoteEntry.js?t=1790757164506');
    resolve(module);
  } catch (error) {
    // console.error('Failed to load remote:', error);
    resolve(null);
  }
})
;